export enum ButtonSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export default ButtonSize;
